export default "__VITE_ASSET___Yyzq8bt__"